<!-- NO FILTERS -->

<!-- FILTERS CONFIGURED -->
@if (form) {
  <form [formGroup]="form" class="fx fx--v">
    <div id="e2e-cbrefilters" class="fx--h fx--wrap filters filters__gap">
      @for (filter of filters$(); track filter; let i = $index) {
        <!-- single -->
        @if (filter.type !== 'group' && filter.associations == null) {
          <div
            id="e2e-cbrefilter-{{ i + 1 }}"
            class="fx--v filter"
            [ngClass]="{ filter__double: filter.type === 'range' }"
            >
            <cbre-filter [form]="form" [filter]="filter" [aggregations]="aggregations()"> </cbre-filter>
          </div>
        }
        <!-- group -->
        @if (filter.type === 'group' && filter.associations?.length > 0) {
          <div class="fx--h filter filter__double filters__gap">
            @for (associatedFilter of filter.associations; track associatedFilter) {
              <cbre-filter
                [form]="form"
                [filter]="associatedFilter"
                [aggregations]="aggregations()"
                >
              </cbre-filter>
            }
            @if (canRemoveFilter()) {
              <mat-icon (click)="removeFilter.emit(filter)">close</mat-icon>
            }
          </div>
        }
      }
    </div>
  </form>
} @else {
  <p class="fx--label">No Filters found.</p>
}
